import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';

import I18n from "../../../../../base/i18n.js.jsx";
import Image from "../../../../../base/components/image.js";
import ProjectStatusEnum from "../../../../../enums/project_status.js";
import ButtonLink from "../../../../../base/links/button_link.js";

import ParticipantInfo from "../../../../../base/user_investments/participant_info.js";

import RevenueAndPeriodBlock from "./revenue_and_period_block.js";
import InvestmentInfoBlock from "./investment_info_block.js";

// TODO: Refactor to single component
// import RevenueAndPeriodInfo from "../../../../../base/components/revenue_and_period_block.js";
// import ProjectsInvestmentsInfo from "../../../../../base/components/projects_investments_info.js";

import SmartLink from '../../../../../base/links/smart_link.js';
import Routes from "../../../../routes.js";
import BonusRatesBlock from "./bonus_rates_block.js.jsx";

const blockStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    borderRadius: "2px",
    boxShadow: "5px 4px 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    "&:not(:last-child)": {
      marginBottom: "32px",
      ['@media (max-width: 992px)']: {
        marginBottom: "28px",
      },
      ['@media (max-width: 768px)']: {
        marginBottom: "24px",
      },
    },
    color: theme.palette.black,
    textDecoration: "none",
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "5px 4px 10px rgba(0, 0, 0, 0.3)",
      transition: "box-shadow 0.3s ease-in-out"
    },
    ['@media (max-width: 992px)']: {
      flexWrap: "wrap",
    },
  },
  img: {
    flexBasis: "60%",
    flexShrink: "0",
    height: "auto",
    ['@media (max-width: 992px)']: {
      flexBasis: "100%",
      minHeight: "178px",
      maxHeight: "300px",
      height: "45vw"
    },
  },
  status: {
    backgroundColor: theme.palette.white,
    borderRadius: "2px",
    color: theme.palette.bronze,
    fontSize: "20px",
    padding: "6px 25px",
    position: "absolute",
    top: "16px",
    left: "16px",
    textTransform: "uppercase",
    zIndex: "1",
    ['@media (max-width: 768px)']: {
      padding: "8px",
      fontSize: "11px",
      lineHeight: "14px"
    },
  },
  infoColumn: {
    backgroundColor: "white",
    padding: "32px",
    flexGrow: "1",
    ['@media (max-width: 768px)']: {
      padding: "22px 18px",
    },
  },
  title: {
    fontSize: "28px",
    lineHeight: "1.15",
    marginTop: "0px",
    marginBottom: "8px",
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: "uppercase",
    ['@media (max-width: 992px)']: {
      fontSize: "24px",
      marginBottom: "-10px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      lineHeight: "22px",
      marginBottom: "-10px",
    },
  },
  subtitle: {
    color: theme.palette.grayText,
    fontSize: "18px",
    lineHeight: "1.3",
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: "0",
    marginBottom: "18px",
    ['@media (max-width: 992px)']: {
      fontSize: "18px",
      marginTop: "1em",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "12px",
      lineHeight: "14px",
      marginBottom: "13px",
    },
  },
  infoRow: {
    margin: "0 -32px",
    ['@media (max-width: 768px)']: {
      margin: "0 -18px",
    },
  },
  button: {
    fontSize: "20px",
    marginTop: "24px",
    padding: "12px 20px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      padding: "10px 20px",
      marginTop: "11px",
    },
  },
  participantInfo: {
    margin: "20px -32px 0px",
    ['@media (max-width: 768px)']: {
      margin: "16px -18px 0px",
    },
  },
  participantInfoInfoRow: {
    padding: "0px 32px",
    marginTop: "25px",
    ['@media (max-width: 768px)']: {
      padding: "0px 16px",
      marginTop: "16px",
    },
  },
  participantInfoDate: {
    fontSize: "14px",
    ['@media (max-width: 768px)']: {
      fontSize: "10px",
    },
  },
  participantInfoMyInvestment: {
    fontSize: "16px",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
    },
  },
  participantInfoMultipleRow: {
    padding: "0px 32px",
    ['@media (max-width: 768px)']: {
      padding: "0px 16px",
    },
  }
}));

const ProjectItem = (props) => {
  const classes = blockStyles();

  const [project, setProject] = useState(props.project);
  const [participant, setParticipant] = useState(props.participant);

  useEffect(() => {
    setProject(props.project);
  }, [props.project])

  useEffect(() => {
    setParticipant(props.participant);
  }, [props.participant])

  const { name, subtitle, status } = project;
  const { mainGalleryImage: { urls } = {} } = project;
  const projectUrl = Routes.project(project);

  let src = undefined;
  let srcSet = {};
  if(urls) {
    src = urls.large;
    srcSet = {
      "2x": urls.large2x,
      "3x": urls.large3x
    }
  }

  return (
    <SmartLink to = { projectUrl }
               className = { classes.root }>
      <div className = { classes.status }>
        { ProjectStatusEnum.label(status) }
      </div>
      <Image className = { classes.img }
              scaleMode = "cover"
              alt = { name }
              src = { src }
              srcSet = { srcSet } />
      <div className = { classes.infoColumn }>
        <div className = { classes.title }>{ name }</div>
        <p className = { classes.subtitle }>{ subtitle }</p>
        <RevenueAndPeriodBlock className = { classes.infoRow }
                               project = { project } />
        <BonusRatesBlock className = { classes.infoRow }
                               project = { project } />
        <InvestmentInfoBlock className = { classes.infoRow }
                             project = { project } />
        <ParticipantInfo participant = { participant }
                         project = { project }
                         className = { classes.participantInfo }
                         classes = { {
                           info: classes.participantInfoInfoRow,
                           date: classes.participantInfoDate,
                           myInvestment: classes.participantInfoMyInvestment,
                           multipleRow: classes.participantInfoMultipleRow
                         } } />
        <ButtonLink className = { classes.button }
                    to = { projectUrl }
                    component = { "span" } >
          { I18n.t("action.go_to_project") }
        </ButtonLink>
      </div>
    </SmartLink>
  );
}

export default ProjectItem;